import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'components/Checkbox';
import Label from 'styled/Label';
import Input from 'styled/Input';
import ChooseFileField from 'admin-editor/components/ChooseFileField';

class ARFormElements extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ChooseFileField
          label="Модель для IOS"
          mediaType="ar"
          accept=".ios"
          name={this.props.IOSModel && this.props.IOSModel.filename}
          onLoad={this.props.onIOSModelLoad}
          isAr
        />

        <ChooseFileField
          label="Модель для Android"
          mediaType="ar"
          accept=".android"
          name={this.props.AndroidModel && this.props.AndroidModel.filename}
          onLoad={this.props.onAndroidModelLoad}
          isAr
        />

        <ChooseFileField
          label="Обложка"
          mediaType="ar"
          accept="image/jpeg,image/png,image/gif"
          name={this.props.cover && this.props.cover.filename}
          onLoad={this.props.onCoverLoad}
        />

        <Label style={{ width: '100%' }}>
          Название модели

          <Input
            type="text"
            value={this.props.title}
            maxLength={80}
            style={{ marginBottom: '24px', color: '#fff' }}
            onChange={this.props.onTitleChange}
          />
        </Label>

        <Checkbox
          id={this.props.checkboxId}
          onChange={this.props.onCheckboxChange}
          checked={this.props.isShowInFeed}
        >
          Показывать в ленте AR
        </Checkbox>
      </React.Fragment>
    );
  }
}

ARFormElements.propTypes = {
  checkboxId: PropTypes.string,
  title: PropTypes.string,
  onIOSModelLoad: PropTypes.func,
  onAndroidModelLoad: PropTypes.func,
  onCoverLoad: PropTypes.func,
  onTitleChange: PropTypes.func,
  onCheckboxChange: PropTypes.func,
  cover: PropTypes.shape({
    filename: PropTypes.string,
    file_type: PropTypes.string,
    file_size: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    medialib_item_id: PropTypes.string,
  }),
  IOSModel: PropTypes.shape({
    filename: PropTypes.string,
    file_type: PropTypes.string,
    file_size: PropTypes.number,
    url: PropTypes.string,
    medialib_item_id: PropTypes.string,
  }),
  AndroidModel: PropTypes.shape({
    filename: PropTypes.string,
    file_type: PropTypes.string,
    file_size: PropTypes.number,
    url: PropTypes.string,
    medialib_item_id: PropTypes.string,
  }),
  isShowInFeed: PropTypes.bool,
};

ARFormElements.defaultProps = {
  checkboxId: '',
  title: '',
  cover: undefined,
  IOSModel: undefined,
  AndroidModel: undefined,
  isShowInFeed: false,
  onIOSModelLoad: () => {},
  onAndroidModelLoad: () => {},
  onCoverLoad: () => {},
  onTitleChange: () => {},
  onCheckboxChange: () => {},
};

export default ARFormElements;
